import React, { useContext, useState } from "react";
import { TabContent } from "Components/ReactstrapSlim";
import { Module, ModuleCaption } from "Components/Module";
import { VenueSearchResult } from "Services/API/API";
import FavoritesTab from "./Tabs/FavoritesTab";
import RecentTab from "./Tabs/RecentTab";
import NearbyTab from "./Tabs/NearbyTab";
import { PortalTab, PortalTabs } from "../PortalTabs";
import { VenueCalendarModal } from "Components/VenueCalendarModal";
import { SearchContext } from "../Main/SearchContextProvider";
import localMomentDate from "Utils/moment/localMomentDate";
import moment from "moment";

interface ExploreModuleProps {
   refreshUpcomingReservationList: () => void;
}

type ActiveTab = 1 | 2 | 3;

export const ExploreModule: React.FC<ExploreModuleProps> = ({ refreshUpcomingReservationList }) => {
   const searchManager = useContext(SearchContext);
   const [activeTab, setActiveTab] = useState<ActiveTab>(1);
   const [bookingVenueId, setBookingVenueId] = useState<Guid | undefined>(undefined);

   const selectTab = (tabId: ActiveTab, ev?: React.SyntheticEvent) => {
      if (ev)
         ev.preventDefault();

      setActiveTab(tabId);
   }


   const onVenueCardClick = (e: React.SyntheticEvent, venue: VenueSearchResult) => {
      setBookingVenueId(venue.venueId);
   }

   const toggleVenueCalendarModal = () => {
      setBookingVenueId(undefined);
   }

   const [controlsElement, setControlsElement] = useState<HTMLDivElement | null>(null);

   const searchStartTime = searchManager.getSearchRequest().startTime;
   const selectedDate = searchStartTime
      ? localMomentDate(moment(searchStartTime)).toISOString()
      : undefined;

   return (<Module size="lg" loading={searchManager.isSearching} style={{ minHeight: "400px" }} withPager id="explore-locations-id">
      <ModuleCaption className="mb-px8">Explore Locations</ModuleCaption>
      <div className="explore-subcaption">
         <PortalTabs>
            <PortalTab active={activeTab == 1} onClick={(e) => selectTab(1, e)}>Nearby</PortalTab>
            <PortalTab active={activeTab == 2} onClick={(e) => selectTab(2, e)}>Recent</PortalTab>
            <PortalTab active={activeTab == 3} onClick={(e) => selectTab(3, e)}>Favorites</PortalTab>
         </PortalTabs>
         <div className="explore-controls" ref={setControlsElement} />
      </div>
      <TabContent>
         {
            activeTab == 1
               ? <NearbyTab onVenueCardClick={onVenueCardClick} controlsElement={controlsElement} />
               : activeTab == 2
                  ? <RecentTab onVenueCardClick={onVenueCardClick} controlsElement={controlsElement} />
                  : activeTab == 3
                     ? <FavoritesTab onVenueCardClick={onVenueCardClick} controlsElement={controlsElement} />
                     : null
         }
      </TabContent>

      {bookingVenueId && <VenueCalendarModal isOpen={!!bookingVenueId} toggle={toggleVenueCalendarModal} refreshUpcomingReservationList={refreshUpcomingReservationList} venueId={bookingVenueId} selectedDate={selectedDate} />}
   </Module>);
}